import type { CSSProperties, ReactNode } from 'react'
import React from 'react'
import type { useToggle } from 'react-use'
import get from 'lodash/get'
import { RenderChildrenRows } from './RenderChildrenRows'

export type TabularTreeItem<T> = {
  root: T
  parent: T
  item: T
  index: number
  level: number
  items: T[]
}

export type TabularTreeRowProps<T> = TabularTreeItem<T> & {
  leftMarginStyle: CSSProperties
  toggleShowChildren: ReturnType<typeof useToggle>
  toggleShowNew: ReturnType<typeof useToggle>
}
export type TabularTreePrimaryRowProps<T> = TabularTreeRowProps<T> & { children: ReactNode }

export type TabularTreeProps<T> = {
  root: T
  head: ReactNode
  row: (props: TabularTreePrimaryRowProps<T>) => ReactNode
  newRow?: (props: TabularTreeRowProps<T>) => ReactNode
  foot?: ReactNode
  childrenKey: string
}

export function TabularTree<T>({ root, head, childrenKey, foot, ...props }: TabularTreeProps<T>) {
  const items = get(root, childrenKey) as T[]
  return (
    <table className="table table-hover">
      {head}
      <tbody>
        <RenderChildrenRows {...props} items={items} parent={root} childrenKey={childrenKey} root={root} level={0} />
      </tbody>
      {foot}
    </table>
  )
}
